import React from 'react';

import Heading from '@atlaskit/heading/heading';
import Image from '@atlaskit/image/image';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import { Text } from '@atlaskit/primitives/compiled/text';

type Props = {
	img: string;
	heading?: string;
	errorText: string[];
};

export default ({ img, heading, errorText }: Props): React.JSX.Element => {
	return (
		<div>
			<Image src={img} alt="" />
			<Stack space="space.150">
				{heading && (
					<Heading as="h1" size="xlarge">
						{heading}
					</Heading>
				)}
				{errorText.map((item, index) => (
					<Text key={'errText_' + index}>{item}</Text>
				))}
			</Stack>
		</div>
	);
};
